define.alias("ember-power-select/components/power-select/placeholder", "preview-grid/components/power-select/placeholder");